/**
 * Consent-gated analytics: Microsoft Clarity + Bing UET.
 *
 * Neither tag loads until Shopify's Customer Privacy API reports that the
 * visitor has granted analytics AND marketing consent. Consent state is
 * also forwarded to Clarity's Consent Mode so its own recording respects
 * the choice. Re-evaluates when the Shopify cookie banner fires
 * visitorConsentCollected, so a visitor who accepts mid-session starts
 * being tracked without a reload.
 *
 * Loaded with `defer` from layout/theme.liquid; it has no Liquid in it.
 */
(function () {
  var CLARITY_ID = 'i93mrjuby2';
  var UET_TAG_ID = '5600189';
  var loaded = false;

  // Define the Clarity queue up front so a second tag (UET can inject one)
  // finds it and does not create a duplicate.
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  function inject(src) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    (document.head || document.documentElement).appendChild(s);
    return s;
  }

  function loadTags() {
    if (loaded || document.querySelector('script[src^="https://www.clarity.ms/tag/"]')) return;
    loaded = true;
    inject('https://www.clarity.ms/tag/' + CLARITY_ID);

    window.uetq = window.uetq || [];
    inject('https://bat.bing.com/bat.js').onload = function () {
      var o = { ti: UET_TAG_ID, enableAutoSpaTracking: true };
      o.q = window.uetq;
      window.uetq = new window.UET(o);
      window.uetq.push('pageLoad');
    };
  }

  function readConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return {
      analytics: !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()),
      marketing: !!(cp && cp.marketingAllowed && cp.marketingAllowed())
    };
  }

  function apply() {
    var consent = readConsent();
    window.clarity('consentv2', {
      analytics_Storage: consent.analytics ? 'granted' : 'denied',
      ad_Storage: consent.marketing ? 'granted' : 'denied'
    });
    if (consent.analytics && consent.marketing) loadTags();
  }

  function init() {
    if (!(window.Shopify && window.Shopify.customerPrivacy)) return false;
    apply();
    document.addEventListener('visitorConsentCollected', apply);
    return true;
  }

  function start() {
    if (init()) return;
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        init();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
